import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const customConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        primary: { value: "#f2ca50" },
        gold: { value: "#D4AF37" },
        surface: { value: "#131313" },
        surfaceLow: { value: "#1c1b1b" },
        surfaceHigh: { value: "#2a2a2a" },
        secondary: { value: "#d6bcf4" },
      },
      fonts: {
        heading: { value: "'Noto Serif', serif" },
        body: { value: "'Manrope', sans-serif" },
      },
    },
    breakpoints: {
      sm: "320px",
      md: "768px",
      lg: "960px",
      xl: "1200px",
    },
  },
});

export const celestialSystem = createSystem(defaultConfig, customConfig);

